import { queryOptions } from '@tanstack/react-query'
import { receiptApi } from './api'
import { ReceiptFilter } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const receiptQueries = {
  all: () => ['receipts'],
  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...receiptQueries.all(), id],
      queryFn: () => receiptApi.retrieve(id),
      enabled: Boolean(id),
    }),
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<ReceiptFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) =>
    queryOptions({
      queryKey: [...receiptQueries.all(), filters, pagination],
      queryFn: async () => {
        const res = await receiptApi.list({ filters, pagination })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    }),
}
